export default "__VITE_ASSET__7f95af16__"